import {environment} from '../../config/environment';
import {api} from '../../shared/utils';
import {fetchAllPages} from '../../shared/utils/fetchAllPages';

const baseUrl = environment.apiBaseURLClients;
const ROLES_PAGE_SIZE = 100;

const buildQuery = (params = {}) => {
    const query = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
        if (value == null || value === '') return;
        query.set(key, value);
    });
    return query.toString();
};

export const listUsers = (params = {}) => {
    const query = buildQuery(params);
    return api.get(`${baseUrl}/auth/users${query ? `?${query}` : ''}`);
};

export const createUser = (payload) => api.post(`${baseUrl}/auth/users`, payload);

// Quem está logado, com o papel em cada assinatura (vinculos). Não depende de perfil no identity.
export const getMe = () => api.get(`${baseUrl}/auth/users/me`);

export const listRolesReference = () => fetchAllPages((page) => (
    api.get(`${baseUrl}/auth/roles?${buildQuery({page, size: ROLES_PAGE_SIZE})}`)
), {firstPage: 0});

export const listLicencasReference = () => api.get(`${baseUrl}/licencas?page=1&pageSize=300&sortBy=atualizado_em&order=desc`);
